import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/** 24-hour rolling countdown timer that resets per browser session. */
export default function CountdownTimer({ hours = 24, label = "Sale ends in", className = "" }) {
  const [endTs] = useState(() => {
    const key = "be_offer_end";
    const cached = parseInt(sessionStorage.getItem(key) || "0", 10);
    if (cached > Date.now()) return cached;
    const end = Date.now() + hours * 3600 * 1000;
    sessionStorage.setItem(key, String(end));
    return end;
  });
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const remaining = Math.max(0, endTs - now);
  const h = Math.floor(remaining / 3600000);
  const m = Math.floor((remaining % 3600000) / 60000);
  const s = Math.floor((remaining % 60000) / 1000);
  const pad = (v) => String(v).padStart(2, "0");

  return (
    <div className={`flex items-center gap-2 rounded-md bg-[color:var(--brand-amber-soft)] px-3 py-2 text-xs ${className}`} data-testid="countdown-timer">
      <Clock className="h-3.5 w-3.5 text-[color:var(--brand-amber-hover)]" />
      <span className="font-semibold text-[color:var(--brand-navy)]">{label}</span>
      <span className="font-mono font-bold text-[color:var(--brand-navy)]">
        {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </div>
  );
}
